/**
 * Client-minted command ids (idempotency keys, ARCHITECTURE §4).
 *
 * `crypto.randomUUID` only exists in SECURE contexts (https / localhost). The
 * WMS is also reached over plain http inside the warehouse LAN (NodePort,
 * pre-TLS bring-up), where calling it throws
 * "globalThis.crypto.randomUUID is not a function" — found live by E2E when
 * the portal could not submit an order. `getRandomValues` has no such
 * restriction, so fall back to a spec-correct v4 built from it.
 */
export function commandId(): string {
  const c = globalThis.crypto;
  if (typeof c?.randomUUID === 'function') return c.randomUUID();

  const bytes = new Uint8Array(16);
  c.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
